<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    @click:row="selectRow"
                ></v-data-table>
            </v-col>
        </v-row>
        <v-row v-if="Boolean(clicked_obj)">
            <v-col cols="12">
                <h1>{{clicked_obj}}</h1>
                <v-data-table
                    :headers="info_header"
                    :items="info"
                ></v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
    data() {
        return {
            headers: [
                {'text': 'Tipo de conector', 'value': 'cdb_type'},
                {'text': 'Porcentaje', 'value': 'percent'},
                {'text': 'Núm. Usuarios', 'value': 'count'},
            ], 
            clicked_obj: '',
            info_header: [
                {'text': 'Usuario', 'value': 'user'},
                {'text': 'Fecha', 'value': 'date'}
            ],
            info: [],
        }
    },
    props: {

    },
    computed: { 
        ...mapFields('kpis', [
            'kpi', 
            'kpis_data', 
        ]),
        items() {
            let items = [];
            if (this.kpis_data && 'percent' in this.kpis_data) {
                let header = Object.keys(this.kpis_data['percent'])
                for (let i in header) {
                    items.push({ 'cdb_type': header[i], 'percent': this.kpis_data['percent'][header[i]] + ' %' ,'count': this.kpis_data['counts'][header[i]]})
                }
            }
            return items;
        },
    },
    methods: {
        selectRow(row) {
            this.info = [];
            this.clicked_obj = row['cdb_type'];
            for (let i in this.kpis_data['info']) {
                if (this.kpis_data['info'][i]['cdb_type'] == row['cdb_type']) {
                    this.info.push({
                        'user': this.kpis_data['info'][i]['user'],
                        'date': this.kpis_data['info'][i]['date']
                    });
                }
            }
        }
    },
    mounted() {
        
    },
};
</script>
<style scoped>
</style>